/* eslint-disable max-lines */
export const InformedOfMedicals = "InformedOfMedicals";
export const PrivacyStatementConfirmation = "PrivacyStatementConfirmation";
export const InformationHeldSecurelyConfirmation = "InformationHeldSecurelyConfirmation";
export const PhotographicIdSeen = "PhotographicIdSeen";

export const HealthUnableToCarryOut = "HealthUnableToCarryOut";
export const HealthUnableToCarryOutReason = "HealthUnableToCarryOutReason";
export const Height = "Height";
export const Weight = "Weight";
export const Bmi = "Bmi";
export const SystolicBloodPressure = "SystolicBloodPressure";
export const DiastolicBloodPressure = "DiastolicBloodPressure";
export const SystolicBloodPressureTwo = "SystolicBloodPressureTwo";
export const DiastolicBloodPressureTwo = "DiastolicBloodPressureTwo";
export const SystolicBloodPressureThree = "SystolicBloodPressureThree";
export const DiastolicBloodPressureThree = "DiastolicBloodPressureThree";
export const SystolicBloodPressureFour = "SystolicBloodPressureFour";
export const DiastolicBloodPressureFour = "DiastolicBloodPressureFour";
export const SystolicBloodPressureFive = "SystolicBloodPressureFive";
export const DiastolicBloodPressureFive = "DiastolicBloodPressureFive";
export const PulseRate = "PulseRate";
export const Cholesterol = "Cholesterol";
export const Psa = "Psa";
export const Whisper = "Whisper";
export const WhisperRightEarPassed = "WhisperRightEarPassed";
export const WhisperLeftEarPassed = "WhisperLeftEarPassed";
export const BloodSugar = "BloodSugar";
export const OnReviewOfQuestionnaireByEmployeeHaveTheyTickedYesToAny = "OnReviewOfQuestionnaireByEmployeeHaveTheyTickedYesToAny";
export const PleaseProvideFurtherInformationOnTheConditionSymptomsHighlighted = "PleaseProvideFurtherInformationOnTheConditionSymptomsHighlighted";
export const PulseRhythm = "PulseRhythm";
export const GPSelfReferralLetterIssuedRegardingBloodPressureOrPulse = "GPSelfReferralLetterIssuedRegardingBloodPressureOrPulse";
export const BloodLeftEar = "BloodLeftEar";
export const BloodRightEar = "BloodRightEar";
export const GPSelefReferralLetterIssuedRegardingWhisperTestResult = "GPSelefReferralLetterIssuedRegardingWhisperTestResult";

export const DrugAlcoholTestUnableToCarryOut = "DrugAlcoholTestUnableToCarryOut";
export const DrugAlcoholTestUnableToCarryOutReason = "DrugAlcoholTestUnableToCarryOutReason";
export const InstantSubstanceAbuseTest = "InstantSubstanceAbuseTest";
export const InstantSubstanceAbuseTestResults = "InstantSubstanceAbuseTestResults";
export const LabSubstanceAbuseTest = "LabSubstanceAbuseTest";
export const AlcoholBreathTest = "AlcoholBreathTest";
export const AlcoholBreathTestResults = "AlcoholBreathTestResults";

export const UrinalysisUnableToCarryOut = "UrinalysisUnableToCarryOut";
export const UrinalysisUnableToCarryOutReason = "UrinalysisUnableToCarryOutReason";
export const UrinalysisProtein = "UrinalysisProtein";
export const UrinalysisGlucose = "UrinalysisGlucose";
export const UrinalysisBlood = "UrinalysisBlood";
export const UrinalysisSelfReferralLetterIssued = "UrinalysisSelfReferralLetterIssued";

export const MsdAssessmentUnableToCarryOut = "MsdAssessmentUnableToCarryOut";
export const MsdAssessmentUnableToCarryOutReason = "MsdAssessmentUnableToCarryOutReason";
export const DemonstratedFullMovementOfNeck = "DemonstratedFullMovementOfNeck";
export const DemonstratedFullMovementOfBack = "DemonstratedFullMovementOfBack";
export const DemonstratedFullMovementOfLeftShoulder = "DemonstratedFullMovementOfLeftShoulder";
export const DemonstratedFullMovementOfLeftElbow = "DemonstratedFullMovementOfLeftElbow";
export const DemonstratedFullMovementOfRightShoulder = "DemonstratedFullMovementOfRightShoulder";
export const DemonstratedFullMovementOfRightElbow = "DemonstratedFullMovementOfRightElbow";
export const DemonstratedFullMovementOfLeftWrist = "DemonstratedFullMovementOfLeftWrist";
export const DemonstratedFullMovementOfLeftLeg = "DemonstratedFullMovementOfLeftLeg";
export const DemonstratedFullMovementOfRightWrist = "DemonstratedFullMovementOfRightWrist";
export const DemonstratedFullMovementOfRightLeg = "DemonstratedFullMovementOfRightLeg";
export const DoRestrictionsAffectPerformance = "DoRestrictionsAffectPerformance";
export const DoRestrictionsAffectPerformanceNotes = "DoRestrictionsAffectPerformanceNotes";

export const MSKManualHandlingAssessmentRequired = "MSKManualHandlingAssessmentRequired";
export const MSKManualHandlingUnableToCarryOut = "MSKManualHandlingUnableToCarryOut";
export const MSKManualHandlingUnableToCarryOutReason = "MSKManualHandlingUnableToCarryOutReason";
export const MSKManualHandlingDemonstratedFullMovementOfNeck = "MSKManualHandlingDemonstratedFullMovementOfNeck";
export const MSKManualHandlingDemonstratedFullMovementOfBack = "MSKManualHandlingDemonstratedFullMovementOfBack";
export const MSKManualHandlingDemonstratedFullMovementOfLeftShoulder = "MSKManualHandlingDemonstratedFullMovementOfLeftShoulder";
export const MSKManualHandlingDemonstratedFullMovementOfLeftElbow = "MSKManualHandlingDemonstratedFullMovementOfLeftElbow";
export const MSKManualHandlingDemonstratedFullMovementOfRightShoulder = "MSKManualHandlingDemonstratedFullMovementOfRightShoulder";
export const MSKManualHandlingDemonstratedFullMovementOfRightElbow = "MSKManualHandlingDemonstratedFullMovementOfRightElbow";
export const MSKManualHandlingDemonstratedFullMovementOfLeftWrist = "MSKManualHandlingDemonstratedFullMovementOfLeftWrist";
export const MSKManualHandlingDemonstratedFullMovementOfLeftLeg = "MSKManualHandlingDemonstratedFullMovementOfLeftLeg";
export const MSKManualHandlingDemonstratedFullMovementOfRightWrist = "MSKManualHandlingDemonstratedFullMovementOfRightWrist";
export const MSKManualHandlingDemonstratedFullMovementOfRightLeg = "MSKManualHandlingDemonstratedFullMovementOfRightLeg";
export const MSKManualHandlingDoRestrictionsAffectPerformance = "MSKManualHandlingDoRestrictionsAffectPerformance";
export const MSKManualHandlingDoRestrictionsAffectPerformanceNotes = "MSKManualHandlingDoRestrictionsAffectPerformanceNotes";

export const SkinAssessmentRequired = "SkinAssessmentRequired";
export const AreasOfSkinExamined = "AreasOfSkinExamined";
export const SkinInGoodCondition = "SkinInGoodCondition";
export const SkinCareAdviceProvided = "SkinCareAdviceProvided";
export const GlovesUseAdviceProvided = "GlovesUseAdviceProvided";
export const RightHandColour = "RightHandColour";
export const RightHandConditionOfSkin = "RightHandConditionOfSkin";
export const RightHandLesionsPresent = "RightHandLesionsPresent";
export const LeftHandColour = "LeftHandColour";
export const LeftHandConditionOfSkin = "LeftHandConditionOfSkin";
export const LeftHandLesionsPresent = "LeftHandLesionsPresent";
export const HistoryOfContactWithChemicals = "HistoryOfContactWithChemicals";
export const HistoryOfContactWithOtherSubstances = "HistoryOfContactWithOtherSubstances";
export const HistoryOfPreviousAllergy = "HistoryOfPreviousAllergy";
export const TakingMedicationRegularlyAtPresent = "TakingMedicationRegularlyAtPresent";
export const WorkingEnvironmentCateringCleaning = "WorkingEnvironmentCateringCleaning";
export const WhetherConditionImprovesAwayFromWork = "WhetherConditionImprovesAwayFromWork";
export const FamilyHistoryOfAsthma = "FamilyHistoryOfAsthma";
export const FamilyHistoryOfHayFever = "FamilyHistoryOfHayFever";
export const FamilyHistoryOfEczema = "FamilyHistoryOfEczema";
export const FamilyHistoryOfAnySkinCondition = "FamilyHistoryOfAnySkinCondition";
export const HomeEnvironment = "HomeEnvironment";
export const KnownSkinCondition = "KnownSkinCondition";
export const SkinConditionName = "SkinConditionName";
export const HowLongHadSkinCondition = "HowLongHadSkinCondition";
export const WhoDiagnosedSkinCondition = "WhoDiagnosedSkinCondition";
export const TakeMedicationForSkinCondition = "TakeMedicationForSkinCondition";
export const PartOfBodyAffectedBySkinCondition = "PartOfBodyAffectedBySkinCondition";
export const SkinConditionDryness = "SkinConditionDryness";
export const SkinConditionItching = "SkinConditionItching";
export const SkinConditionRedness = "SkinConditionRedness";
export const SkinConditionScaling = "SkinConditionScaling";
export const SkinConditionCracking = "SkinConditionCracking";
export const SkinConditionFlaking = "SkinConditionFlaking";
export const SkinConditionBlisters = "SkinConditionBlisters";
export const SkinConditionHowLongLast = "SkinConditionHowLongLast";
export const LastIssueWithSkinCondition = "LastIssueWithSkinCondition";
export const NonMedicationImprovementOnSkinCondition = "NonMedicationImprovementOnSkinCondition";
export const AnyCauseDeteriorationToSkinCondition = "AnyCauseDeteriorationToSkinCondition";
export const HistorySwellingOfFaceHands = "HistorySwellingOfFaceHands";
export const HistoryRednessOfFaceHands = "HistoryRednessOfFaceHands";
export const HistorySneezingRunnyEyes = "HistorySneezingRunnyEyes";
export const HistoryCoughShortnessOfBreath = "HistoryCoughShortnessOfBreath";
export const HistoryLatexAllergyConfirmed = "HistoryLatexAllergyConfirmed";
export const HistorySkinConditionDetails = "HistorySkinConditionDetails";

export const AudiometryUnableToCarryOut = "AudiometryUnableToCarryOut";
export const AudiometryUnableToCarryOutReason = "AudiometryUnableToCarryOutReason";
export const AudiometryMachineSerialNumber = "AudiometryMachineSerialNumber";
export const AudiometryCalibrationDate = "AudiometryCalibrationDate";
export const AudiometryReasonForAttending = "AudiometryReasonForAttending";
export const AudiometryDateOfLastTest = "AudiometryDateOfLastTest";
export const AudiometryGender = "AudiometryGender";
export const AudiometryAge = "AudiometryAge";
export const AudiometryLeftEarWaxVisible = "AudiometryLeftEarWaxVisible";
export const AudiometryRightEarWaxVisible = "AudiometryRightEarWaxVisible";
export const AudiometryScarringLeftEar = "AudiometryScarringLeftEar";
export const AudiometryScarringLeftEarComments = "AudiometryScarringLeftEarComments";
export const AudiometryScarringRightEar = "AudiometryScarringRightEar";
export const AudiometryScarringRightEarComments = "AudiometryScarringRightEarComments";
export const AudiometryInfectionCongestionLeftEar = "AudiometryInfectionCongestionLeftEar";
export const AudiometryInfectionCongestionLeftEarComments = "AudiometryInfectionCongestionLeftEarComments";
export const AudiometryInfectionCongestionRightEar = "AudiometryInfectionCongestionRightEar";
export const AudiometryInfectionCongestionRightEarComments = "AudiometryInfectionCongestionRightEarComments";
export const AudiometryEntIssues = "AudiometryEntIssues";
export const AudiometryLeftEar0_500 = "AudiometryLeftEar0_500";
export const AudiometryRightEar0_500 = "AudiometryRightEar0_500";
export const AudiometryLeftEar0_750 = "AudiometryLeftEar0_750";
export const AudiometryRightEar0_750 = "AudiometryRightEar0_750";
export const AudiometryRightEar1_0 = "AudiometryRightEar1_0";
export const AudiometryLeftEar1_0 = "AudiometryLeftEar1_0";
export const AudiometryRightEar1_5 = "AudiometryRightEar1_5";
export const AudiometryLeftEar1_5 = "AudiometryLeftEar1_5";
export const AudiometryRightEar2_0 = "AudiometryRightEar2_0";
export const AudiometryLeftEar2_0 = "AudiometryLeftEar2_0";
export const AudiometryRightEar3_0 = "AudiometryRightEar3_0";
export const AudiometryLeftEar3_0 = "AudiometryLeftEar3_0";
export const AudiometryRightEar4_0 = "AudiometryRightEar4_0";
export const AudiometryLeftEar4_0 = "AudiometryLeftEar4_0";
export const AudiometryRightEar6_0 = "AudiometryRightEar6_0";
export const AudiometryLeftEar6_0 = "AudiometryLeftEar6_0";
export const AudiometryRightEar8_0 = "AudiometryRightEar8_0";
export const AudiometryLeftEar8_0 = "AudiometryLeftEar8_0";
// tslint:enable:variable-name
export const AudiometryRightEarFrequency = "AudiometryRightEarFrequency";
export const AudiometryLeftEarFrequency = "AudiometryLeftEarFrequency";
export const AudiometryUnilateralDifference = "AudiometryUnilateralDifference";
export const AudiometryUnilateralAction = "AudiometryUnilateralAction";
export const AudiometryHearingCategory = "AudiometryHearingCategory";
export const AudiometryResultsExplained = "AudiometryResultsExplained";
export const AudiometryPpeAvailableForInspection = "AudiometryPpeAvailableForInspection";
export const AudiometryPpeComfortableAndFitForPurpose = "AudiometryPpeComfortableAndFitForPurpose";
export const AudiometryPpeComfortableAndFitForPurposeComments = "AudiometryPpeComfortableAndFitForPurposeComments";
export const AudiometryHearingProtectionLeafletOrAdviceGiven = "AudiometryHearingProtectionLeafletOrAdviceGiven";
export const AudiometryReferralRequired = "AudiometryReferralRequired";
export const AudiometryAdviceRecommendationLetterForGpSupplied = "AudiometryAdviceRecommendationLetterForGpSupplied";
export const AudiometryReviewDateRecommended = "AudiometryReviewDateRecommended";
export const AudiometryReviewDateRecommendedComments = "AudiometryReviewDateRecommendedComments";

export const SpirometryUnableToCarryOut = "SpirometryUnableToCarryOut";
export const SpirometryUnableToCarryOutReason = "SpirometryUnableToCarryOutReason";
export const SpirometryMachineSerialNumber = "SpirometryMachineSerialNumber";
export const SpirometryMachineCalibrationDate = "SpirometryMachineCalibrationDate";
export const SpirometryReasonForAttending = "SpirometryReasonForAttending";
export const SpirometryLastTestDate = "SpirometryLastTestDate";
export const SpirometryGender = "SpirometryGender";
export const SpirometryAge = "SpirometryAge";
export const SpirometryTestStartDate = "SpirometryTestStartDate";
export const SpirometryCurrentOrHistoricalIssues = "SpirometryCurrentOrHistoricalIssues";
export const SpirometryEthnicity = "SpirometryEthnicity";
export const SpirometrySmoker = "SpirometrySmoker";
export const SpirometryVcLitres = "SpirometryVcLitres";
export const SpirometryFvcLitres = "SpirometryFvcLitres";
export const SpirometryFvcLitresPredicted = "SpirometryFvcLitresPredicted";
export const SpirometryFvcLitresPercentPredicted = "SpirometryFvcLitresPercentPredicted";
export const SpirometryFev1Litres = "SpirometryFev1Litres";
export const SpirometryFev1LitresPredicted = "SpirometryFev1LitresPredicted";
export const SpirometryFev1LitresPercentPredicted = "SpirometryFev1LitresPercentPredicted";
export const SpirometryFev1FvcRatio = "SpirometryFev1FvcRatio";
export const SpirometryFev1FvcRatioPredicted = "SpirometryFev1FvcRatioPredicted";
export const SpirometryFev1FvcRatioPercentPredicted = "SpirometryFev1FvcRatioPercentPredicted";
export const SpirometryFef2575 = "SpirometryFef2575";
export const SpirometryPefrLitresPerMinute = "SpirometryPefrLitresPerMinute";
export const SpirometryResultsExplained = "SpirometryResultsExplained";
export const SpirometryRequiresRegularFaceFitTesting = "SpirometryReqioresRegularFaceFitTesting";
export const SpirometryUnderstandsImportanceOfBeingCleanShaven = "SpirometryUnderstandsImportanceOfBeingCleanShaven";
export const SpirometryReferredDueToCleanShavenUnderstanding = "SpirometryReferredDueToCleanShavenUnderstanding";
export const SpirometryPpeAvailableForInspection = "SpirometryPpeAvailableForInspection";
export const SpirometryPpeComfortableAndFitForPurpose = "SpirometryPpeComfortableAndFitForPurpose";
export const SpirometryPpeComfortableAndFitForPurposeComments = "SpirometryPpeComfortableAndFitForPurposeComments";
export const SpirometryRespiratoryProtectionLeafletOrAdviceGiven = "SpirometryRespiratoryProtectionLeafletOrAdviceGiven";
export const SpirometryReferralRequired = "SpirometryReferralRequired";
export const SpirometryAdviceRecommendationForGpSupplied = "SpirometryAdviceRecommendationForGpSupplied";
export const SpirometryReviewDateRecommended = "SpirometryReviewDateRecommended";
export const SpirometryReviewDateOtherDetails = "SpirometryReviewDateOtherDetails";

export const VisionUnableToCarryOut = "VisionUnableToCarryOut";
export const VisionUnableToCarryOutReason = "VisionUnableToCarryOutReason";
export const VisionTestType = "VisionTestType";
export const VisionServiceDate = "VisionServiceDate";
export const VisionAge = "VisionAge";
export const VisionRoleType = "VisionRoleType";
export const VisionOtherRoleType = "";
export const VisionLastOpticianTest = "VisionLastOpticianTest";
export const VisionCurrentCorrectionRequired = "VisionCurrentCorrectionRequired";
export const VisionCurrentVisualAidDescription = "VisionCurrentVisualAidDescription";
export const VisionCorrectivePrescriptionUsed = "VisionCorrectivePrescriptionUsed";
export const VisionFamilyHistory = "VisionFamilyHistory";
export const VisionHistoricalCurrentIssues = "VisionHistoricalCurrentIssues";
export const VisionHistoricalCurrentIssuesYesOrNo = "VisionHistoricalCurrentIssuesYesOrNo";
export const VisionHistoricalCurrentIssuesDetails = "VisionHistoricalCurrentIssuesDetails";
export const VisionDistanceCorrectionDistance = "VisionDistanceCorrectionDistance";
export const VisionRightEyeDistance = "VisionRightEyeDistance";
export const VisionLeftEyeDistance = "VisionLeftEyeDistance";
export const VisionBothEyesDistance = "VisionBothEyesDistance";
export const VisionIntermediateCorrection = "VisionIntermediateCorrection";
export const VisionBothEyesIntermediate100Cm = "VisionBothEyesIntermediate100Cm";
export const VisionBothEyesIntermediate60Cm = "VisionBothEyesIntermediate60Cm";
export const VisionNearCorrection = "VisionNearCorrection";
export const VisionDistanceCorrectionNear = "VisionDistanceCorrectionNear";
export const VisionRightEyeNear = "VisionRightEyeNear";
export const VisionLeftEyeNear = "VisionLeftEyeNear";
export const VisionBothEyesNear = "VisionBothEyesNear";
export const VisionNightVision = "VisionNightVision";
export const VisionColourTestType = "VisionColourTestType";
export const VisionColourResult = "VisionColourResult";
export const VisionLeftEyePeripheralField = "VisionLeftEyePeripheralField";
export const VisionRightEyePeripheralField = "VisionRightEyePeripheralField";
export const VisionHorizontalField = "VisionHorizontalField";
export const VisionPhoriaDistance = "VisionPhoriaDistance";
export const VisionPhoriaNear = "VisionPhoriaNear";
export const VisionDepthPerceptionDistance = "VisionDepthPerceptionDistance";
export const VisionDepthPerceptionNear = "VisionDepthPerceptionNear";
export const VisionSafetyGlassesAdequateAndInGoodCondition = "VisionSafetyGlassesAdequateAndInGoodCondition";
export const VisionRemindedToAttendOpticiansRoutinely = "VisionRemindedToAttendOpticiansRoutinely";
export const OpticiansSelfReferralLetterIssued = "OpticiansSelfReferralLetterIssued";
export const EmployeeInformedGlassesAreWornToMeetMinimumStandards = "EmployeeInformedGlassesAreWornToMeetMinimumStandards";
export const EmployeeInformedGlassesAreWornToMeetMinimumStandardsAdditionalNotes = "EmployeeInformedGlassesAreWornToMeetMinimumStandardsAdditionalNotes";

export const HavsAssessmentRequired = "HavsAssessmentRequired";
export const EverSufferedBlanching = "EverSufferedBlanching";
export const BlanchingInResponseToColdDampOrWet = "BlanchingInResponseToColdDampOrWet";
export const BlanchingWhileWorking = "BlanchingWhileWorking";
export const BlanchingOtherTimes = "BlanchingOtherTimes";
export const BlanchingOtherTimesExamples = "BlanchingOtherTimesExamples";
export const BlanchingFirstNoticed = "BlanchingFirstNoticed";
export const BlanchingHowOften = "BlanchingHowOften";
export const BlanchingMostCommonCircumstances = "BlanchingMostCommonCircumstances";
export const ExperienceWhitenessInFeetOrOtherPeriphery = "ExperienceWhitenessInFeetOrOtherPeriphery";
export const ExperienceWhitenessInFeetOrOtherPeripheryWhere = "ExperienceWhitenessInFeetOrOtherPeripheryWhere";
export const WhichFingersAffectedByBlanching = "WhichFingersAffectedByBlanching";
export const BlanchingWitnessed = "BlanchingWitnessed";
export const BlanchingNotWitnessed = "BlanchingNotWitnessed";
export const Tingling = "Tingling";
export const ExperienceTinglingOfFingers = "ExperienceTinglingOfFingers";
export const TinglingResponseToCold = "TinglingResponseToCold";
export const TinglingWithBlanching = "TinglingWithBlanching";
export const TinglingWhileWorking = "TinglingWhileWorking";
export const TinglingAtOtherTimes = "TinglingAtOtherTimes";
export const TinglingAtOtherTimesExamples = "TinglingAtOtherTimesExamples";
export const TinglingWhenFirstNoticed = "TinglingWhenFirstNoticed";
export const TinglingWhichFingersAffected = "TinglingWhichFingersAffected";
export const Numbness = "Numbness";
export const DoFingersGoNumb = "DoFingersGoNumb";
export const NumbnessResponseToCold = "NumbnessResponseToCold";
export const NumbnessWithBlanching = "NumbnessWithBlanching";
export const NumbnessWhileWorking = "NumbnessWhileWorking";
export const NumbnessOtherTimes = "NumbnessOtherTimes";
export const NumbnessOtherTimesExamples = "NumbnessOtherTimesExamples";
export const NumbnessFirstNotice = "NumbnessFirstNotice";
export const NumbnessWhichFingers = "NumbnessWhichFingers";
export const NumbnessDifficultyHandlingSmallObjects = "NumbnessDifficultyHandlingSmallObjects";
export const NumbnessDifficultyHandlingSmallObjectsWhen = "NumbnessDifficultyHandlingSmallObjectsWhen";
export const AnyBlanchingTinglingNumbnessAffectWorkOrLeisure = "AnyBlanchingTinglingNumbnessAffectWorkOrLeisure";
export const AnyBlanchingTinglingNumbnessAffectWorkOrLeisureFurtherDetails = "AnyBlanchingTinglingNumbnessAffectWorkOrLeisureFurtherDetails";
export const ProblemsWithMusclesOrJoints = "ProblemsWithMusclesOrJoints";
export const ProblemsWithMusclesOrJointsFurtherDetails = "ProblemsWithMusclesOrJointsFurtherDetails";
export const Pain = "Pain";
export const PainFurtherDetails = "PainFurtherDetails";
export const Stiffness = "Stiffness";
export const StiffnessFurtherDetails = "StiffnessFurtherDetails";
export const Swelling = "Swelling";
export const SwellingFurtherDetails = "SwellingFurtherDetails";
export const Weakness = "Weakness";
export const WeaknessFurtherDetails = "WeaknessFurtherDetails";
export const DominantHand = "DominantHand";
export const LeadingHand = "LeadingHand";
export const FirstStartUsingVibrating = "FirstStartUsingVibrating";
export const WhereNoticeVibrationMost = "WhereNoticeVibrationMost";
export const WhenStopUsingVibratingTools = "WhenStopUsingVibratingTools";
export const MainElementsJobInvolvingVibratingTools = "MainElementsJobInvolvingVibratingTools";
export const WhenJoinCompany = "WhenJoinCompany";
export const MainJobsAndDepartments = "MainJobsAndDepartments";
export const PreviousJobsInvolvingVibrations = "PreviousJobsInvolvingVibrations";
export const ExposureToChemicalsAtWork = "ExposureToChemicalsAtWork";
export const ExposureToChemicalsAtWorkFurtherDetails = "ExposureToChemicalsAtWorkFurtherDetails";
export const HandArmVibrationHobbies = "HandArmVibrationHobbies";
export const HandArmVibrationHobbiesFurtherDetails = "HandArmVibrationHobbiesFurtherDetails";
export const DoYouSmoke = "DoYouSmoke";
export const HowManySmokePerDay = "HowManySmokePerDay";
export const ExSmoker = "ExSmoker";
export const ExSmokerWhenQuit = "ExSmokerWhenQuit";
export const DrinkAlcohol = "DrinkAlcohol";
export const DrinkAlcoholNumberOfUnitsPerWeek = "DrinkAlcoholNumberOfUnitsPerWeek";
export const CloseFamilyVibrationWhiteFinger = "CloseFamilyVibrationWhiteFinger";
export const CloseFamilyVibrationWhiteFingerWho = "CloseFamilyVibrationWhiteFingerWho";
export const EverNeckArmHandInjuryOrOperation = "EverNeckArmHandInjuryOrOperation";
export const EverNeckArmHandInjuryOrOperationWhatWhen = "EverNeckArmHandInjuryOrOperationWhatWhen";
export const EverNeckArmHandInjuryOrOperationAnyProblems = "EverNeckArmHandInjuryOrOperationAnyProblems";
export const EverNeckArmHandInjuryOrOperationAnyProblemsFurtherDetails = "EverNeckArmHandInjuryOrOperationAnyProblemsFurtherDetails";
export const SeriousDiseaseJoints = "SeriousDiseaseJoints";
export const SeriousDiseaseJointsFurtherDetails = "SeriousDiseaseJointsFurtherDetails";
export const SeriousDiseaseSkin = "SeriousDiseaseSkin";
export const SeriousDiseaseSkinFurtherDetails = "SeriousDiseaseSkinFurtherDetails";
export const SeriousDiseaseNerves = "SeriousDiseaseNerves";
export const SeriousDiseaseNervesFurtherDetails = "SeriousDiseaseNervesFurtherDetails";
export const SeriousDiseaseHeartBloodVessels = "SeriousDiseaseHeartBloodVessels";
export const SeriousDiseaseHeartBloodVesselsFurtherDetails = "SeriousDiseaseHeartBloodVesselsFurtherDetails";
export const SeriousDiseaseOther = "SeriousDiseaseOther";
export const SeriousDiseaseOtherFurtherDetails = "SeriousDiseaseOtherFurtherDetails";
export const AnyLongTermMedicationTreatmentForCondition = "AnyLongTermMedicationTreatmentForCondition";
export const AnyLongTermMedicationTreatmentForConditionFurtherDetails = "AnyLongTermMedicationTreatmentForConditionFurtherDetails";

export const ExaminationUnableToCarryOut = "ExaminationUnableToCarryOut";
export const ExaminationUnableToCarryOutReason = "ExaminationUnableToCarryOutReason";
export const LastExposureToVibration = "LastExposureToVibration";
export const RoomTemperature = "RoomTemperature";
export const AppearanceOfHands = "AppearanceOfHands";
export const RightPulseRate = "RightPulseRate";
export const LeftPulseRate = "LeftPulseRate";
export const RightBloodPressure = "RightBloodPressure";
export const LeftBloodPressure = "LeftBloodPressure";
export const RightPositiveRadialPulse = "RightPositiveRadialPulse";
export const RightAbsentRadialPulse = "RightAbsentRadialPulse";
export const LeftPositiveRadialPulse = "LeftPositiveRadialPulse";
export const LeftAbsentRadialPulse = "LeftAbsentRadialPulse";
export const RightPositiveUlnarPulse = "RightPositiveUlnarPulse";
export const RightAbsentUlnarPulse = "RightAbsentUlnarPulse";
export const LeftPositiveUlnarPulse = "LeftPositiveUlnarPulse";
export const LeftAbsentUlnarPulse = "LeftAbsentUlnarPulse";
export const RightPositiveAllensTest = "RightPositiveAllensTest";
export const RightNegativeAllensTest = "RightNegativeAllensTest";
export const LeftPositiveAllensTest = "LeftPositiveAllensTest";
export const LeftNegativeAllensTest = "LeftNegativeAllensTest";
export const RightNormalSemmesWeinstein = "RightNormalSemmesWeinstein";
export const RightAbnormalSemmesWeinstein = "RightAbnormalSemmesWeinstein";
export const LeftNormalSemmesWeinstein = "LeftNormalSemmesWeinstein";
export const LeftAbnormalSemmesWeinstein = "LeftAbnormalSemmesWeinstein";
export const RightNormalPurduePegboardTest = "RightNormalPurduePegboardTest";
export const RightAbnormalPurduePegboardTest = "RightAbnormalPurduePegboardTest";
export const LeftNormalPurduePegboardTest = "LeftNormalPurduePegboardTest";
export const LeftAbnormalPurduePegboardTest = "LeftAbnormalPurduePegboardTest";
export const RightNormalAdsonsTest = "RightNormalAdsonsTest";
export const RightAbnormalAdsonsTest = "RightAbnormalAdsonsTest";
export const LeftNormalAdsonsTest = "LeftNormalAdsonsTest";
export const LeftAbnormalAdsonsTest = "LeftAbnormalAdsonsTest";
export const RightNormalTinelsTest = "RightNormalTinelsTest";
export const RightAbnormalTinelsTest = "RightAbnormalTinelsTest";
export const LeftNormalTinelsTest = "LeftNormalTinelsTest";
export const LeftAbnormalTinelsTest = "LeftAbnormalTinelsTest";
export const RightNormalPhalensTest = "RightNormalPhalensTest";
export const RightAbnormalPhalensTest = "RightAbnormalPhalensTest";
export const LeftNormalPhalensTest = "LeftNormalPhalensTest";
export const LeftAbnormalPhalensTest = "LeftAbnormalPhalensTest";
export const AbnormalityOfNecksOrUpperLimbs = "AbnormalityOfNecksOrUpperLimbs";
export const RightGripStrength1 = "RightGripStrength1";
export const RightGripStrength2 = "RightGripStrength2";
export const RightGripStrength3 = "RightGripStrength3";
export const RightGripStrengthAverage = "RightGripStrengthAverage";
export const LeftGripStrength1 = "LeftGripStrength1";
export const LeftGripStrength2 = "LeftGripStrength2";
export const LeftGripStrength3 = "LeftGripStrength3";
export const LeftGripStrengthAverage = "LeftGripStrengthAverage";
export const PrimaryRaynaudsPhenomenonPresent = "PrimaryRaynaudsPhenomenonPresent";
export const SecondaryRaynaudsPhenomenonPresent = "SecondaryRaynaudsPhenomenonPresent";
export const RaynaudsPhenomenonPresentVibrationInduced = "RaynaudsPhenomenonPresentVibrationInduced";
export const RightStockholmVascularGrading = "RightStockholmVascularGrading";
export const LeftStockholmVascularGrading = "LeftStockholmVascularGrading";
export const NeurologicalImpairmentSuggested = "NeurologicalImpairmentSuggested";
export const CarpalTunnelSyndromeSuggested = "CarpalTunnelSyndromeSuggested";
export const RightStockholmSensorineuralGrading = "RightStockholmSensorineuralGrading";
export const LeftStockholmSensorineuralGrading = "LeftStockholmSensorineuralGrading";
export const MuscularSoftTissueDisorderPresent = "MuscularSoftTissueDisorderPresent";
export const EvidenceSkeletalDisorder = "EvidenceSkeletalDisorder";
export const VascularLatentPeriods = "VascularLatentPeriods";
export const NeurologicalLatentPeriods = "NeurologicalLatentPeriods";
export const MusculoskeletalLatentPeriods = "MusculoskeletalLatentPeriods";
export const VibrotactileThresholdFurtherInvestigationsRequired = "VibrotactileThresholdFurtherInvestigationsRequired";
export const TemperatureThresholdFurtherInvestigationsRequired = "TemperatureThresholdFurtherInvestigationsRequired";
export const AdditionalClinicalNotes = "AdditionalClinicalNotes";

export const AdvisedEmployeeTemporarilyUnfitToCarryOutDuties = "AdvisedEmployeeTemporarilyUnfitToCarryOutDuties";
export const PleaseDocumentTheReasonsForTheAboveDecision = "PleaseDocumentTheReasonsForTheAboveDecision";
export const AdvisedToDiscussTemporarilyUnfitStatusWithLineManager = "AdvisedToDiscussTemporarilyUnfitStatusWithLineManager";
export const InformedCaseWillBeAssessedByOha = "InformedCaseWillBeAssessedByOha";
export const ConfirmIfEmployeeHasProvidedConsentToProvideInformationToEmployer = "ConfirmIfEmployeeHasProvidedConsentToProvideInformationToEmployer";
export const ProvideDetailsOfTheConsent = "ProvideDetailsOfTheConsent";
export const GeneralNotes = "GeneralNotes";
export const MedicalDocuments = "MedicalDocuments";
export const AnyDocumentsSentViaPost = "AnyDocumentsSentViaPost";
export const ConsentGiven = "ConsentGiven";

export const BiologicalMonitoringUnableToCarryOut = "BiologicalMonitoringUnableToCarryOut";
export const BiologicalMonitoringUnableToCarryOutReason = "BiologicalMonitoringUnableToCarryOutReason";
export const BiologicalMonitoringSampleTaken = "BiologicalMonitoringSampleTaken";
export const BiologicalMonitoringSampleTakenOtherDetails = "BiologicalMonitoringSampleTakenOtherDetails";
export const BiologicalMonitoringSubstancesBeingTestedFor = "BiologicalMonitoringSubstancesBeingTestedFor";
export const BiologicalMonitoringLaboratorySentTo = "BiologicalMonitoringLaboratorySentTo";
export const BiologicalMonitoringClinicalNotes = "BiologicalMonitoringClinicalNotes";

export const HavsTier = "HavsTier";
export const ClinicalAssessmentOfHavsSignsAndSymptomReview = "ClinicalAssessmentOfHavsSignsAndSymptomReview";
export const TierOneOutcome = "TierOneOutcome";
export const AdditionalAdviceAndRecallPlan = "AdditionalAdviceAndRecallPlan";
export const TierTwoOutcome = "TierTwoOutcome";
export const BlanchingWitnessedByPersonCompletingScreening = "BlanchingWitnessedByPersonCompletingScreening";
export const PreviousJobsInvolvingVibrationsUpdated = "PreviousJobsInvolvingVibrationsUpdated";
export const EverNeckArmHandInjuryOrOperationUpdated = "EverNeckArmHandInjuryOrOperationUpdated";
export const RadialPulseRight = "RadialPulseRight";
export const RadialPulseLeft = "RadialPulseLeft";
export const UlnarPulseRight = "UlnarPulseRight";
export const UlnarPulseLeft = "UlnarPulseLeft";
export const AllensTestRight = "AllensTestRight";
export const AllensTestLeft = "AllensTestLeft";
export const SemmesWeinsteinRight = "SemmesWeinsteinRight";
export const SemmesWeinsteinRightScore = "SemmesWeinsteinRightScore";
export const SemmesWeinsteinLeft = "SemmesWeinsteinLeft";
export const SemmesWeinsteinLeftScore = "SemmesWeinsteinLeftScore";
export const ManualDexterityRight = "ManualDexterityRight";
export const ManualDexterityRightScore = "ManualDexterityRightScore";
export const ManualDexterityLeft = "ManualDexterityLeft";
export const ManualDexterityLeftScore = "ManualDexterityLeftScore";
export const ManualDexterityBothScore = "ManualDexterityBothScore";
export const AdsonsTestRight = "AdsonsTestRight";
export const AdsonsTestLeft = "AdsonsTestLeft";
export const TinelsTestRight = "TinelsTestRight";
export const TinelsTestLeft = "TinelsTestLeft";
export const PhelansTestRight = "PhelansTestRight";
export const PhelansTestLeft = "PhelansTestLeft";
export const AdvisoryLeafletReceivedByEmployee = "AdvisoryLeafletReceivedByEmployee";
export const TinglingWhichFingersAffectedUpdated = "TinglingWhichFingersAffectedUpdated";

// Grip Strength section questions
export const GripStrengthUnableToCarryOut = "GripStrengthUnableToCarryOut";
export const GripStrengthUnableToCarryOutReason = "GripStrengthUnableToCarryOutReason";
export const GripStrengthLeftHandMeasurement1 = "GripStrengthLeftHandMeasurement1";
export const GripStrengthLeftHandMeasurement2 = "GripStrengthLeftHandMeasurement2";
export const GripStrengthLeftHandMeasurement3 = "GripStrengthLeftHandMeasurement3";
export const GripStrengthLeftHandAverageMeasurement = "GripStrengthLeftHandAverageMeasurement";
export const GripStrengthRightHandMeasurement1 = "GripStrengthRightHandMeasurement1";
export const GripStrengthRightHandMeasurement2 = "GripStrengthRightHandMeasurement2";
export const GripStrengthRightHandMeasurement3 = "GripStrengthRightHandMeasurement3";
export const GripStrengthRightHandAverageMeasurement = "GripStrengthRightHandAverageMeasurement";

// Bideltoid Measurement section questions
export const BideltoidMeasurementUnableToCarryOut = "BideltoidMeasurementUnableToCarryOut";
export const BideltoidMeasurementUnableToCarryOutReason = "BideltoidMeasurementUnableToCarryOutReason";
export const BideltoidMeasurementMeasurement1 = "BideltoidMeasurementMeasurement1";
export const BideltoidMeasurementMeasurement2 = "BideltoidMeasurementMeasurement2";
export const BideltoidMeasurementMeasurement3 = "BideltoidMeasurementMeasurement3";
export const BideltoidMeasurementAverageMeasurement = "BideltoidMeasurementAverageMeasurement";

// Chester step
// Section 1
export const ChesterStepUnableToCarryOutMedical = "ChesterStepUnableToCarryOutMedical";
export const ChesterStepUnableToCarryOutMedicalFurtherDetails = "ChesterStepUnableToCarryOutMedicalFurtherDetails";
export const HasYourDoctorEverSaidThatYouHaveAHeartCondition
    = "HasYourDoctorEverSaidThatYouHaveAHeartConditionAndThatYouShouldOnlyDoPhysicalActivityRecommendedByADoctor";
export const DoYouFeelPainInYourChestWhenYouDoPhysicalActivities = "DoYouFeelPainInYourChestWhenYouDoPhysicalActivities";
export const InThePastMonthHaveYouHadChestPainWhenYouWereNotDoingPhysicalActivity = "InThePastMonthHaveYouHadChestPainWhenYouWereNotDoingPhysicalActivity";
export const DoYouLoseYourBalanceBecauseOfDizzinessOrDoYouEverLoseConsciousness = "DoYouLoseYourBalanceBecauseOfDizzinessOrDoYouEverLoseConsciousness";
export const DoYouHaveABoneOrJointProblemThatCouldBeMadeWorseByAChangeInPhysicalActivity
    = "DoYouHaveABoneOrJointProblemForExampleBackKneeOrHipThatCouldBeMadeWorseByAChangeInPhysicalActivity";
export const IsYourDoctorCurrentlyPrescribingDrugsForBloodPressureOrAHeartCondition
    = "IsYourDoctorCurrentlyPrescribingDrugsForExampleWaterPillsForBloodPressureOrAHeartCondition";
export const DoYouKnowOfAnyOtherReasonsWhyYouShouldNotDoPhysicalActivity = "DoYouKnowOfAnyOtherReasonsWhyYouShouldNotDoPhysicalActivity";
export const DoYouSufferFromDiabetes = "DoYouSufferFromDiabetes";
export const DoYouSufferFromStomachOrIntestinalDisorders = "DoYouSufferFromStomachOrIntestinalDisorders";
// Section 1b
export const IfYesToAnyAerobicFitnessAssessmentShouldBePostponed = "IfYesToAnyAerobicFitnessAssessmentShouldBePostponed";
// Section 1c
export const ChesterStepTypeOfTest = "ChesterStepTypeOfTest";
// Section 2 - Chester Step
export const IsTheRoomQuietWellVentilatedAndBetween18To20DegreesCelsius = "IsTheRoomQuietWellVentilatedAndBetween18To20DegreesCelsius";
export const IsThereEasyAccessToATelephoneOrHotlineForEmergencyMedicalServicesWithAGeographicDescriptionOfTheSiteAccessAndLocation
    = "IsThereEasyAccessToATelephoneOrHotlineForEmergencyMedicalServicesWithAGeographicDescriptionOfTheSiteAccessAndLocation";
export const HaveYouCheckedTheAutomatedExternalDefibrillatorIsChargedAndAvailable = "HaveYouCheckedTheAutomatedExternalDefibrillatorIsChargedAndAvailable";
export const HaveYouHadTrainingInTheUseOfAnExternalAutomatedDefibrillator = "HaveYouHadTrainingInTheUseOfAnExternalAutomatedDefibrillator";
export const HaveYouCheckedTheStepIsSecure = "HaveYouCheckedTheStepIsSecure";
export const DoesTheHeartRateMonitorWork = "DoesTheHeartRateMonitorWork";
export const DoesTheMetronomeWork = "DoesTheMetronomeWork";
export const HaveYouHadBLSTraining = "HaveYouHadBLSTraining";
export const HaveYouCheckedThereAreNoContraIndicationsIdentified = "HaveYouCheckedThereAreNoContraIndicationsIdentified";
export const HaveTheySuitableWearingLooseFittingComfortableClothing = "HaveTheySuitableWearingLooseFittingComfortableClothing";
export const HaveYouCheckedThatTheSubjectHasNotEatenSmokedDrunkTeaOrCoffeeForAtLeastTwoHoursBeforeTheTest
    = "HaveYouCheckedThatTheSubjectHasNotEatenSmokedDrunkTeaOrCoffeeForAtLeastTwoHoursBeforeTheTest";
export const HaveYouBriefedThemOnTheTest = "HaveYouBriefedThemOnTheTest";
export const HaveYouCheckedThatTheSubjectIsNotSufferingFromAnyMuscularInjuryConditionWhichWillAffectHisHerAbility
    = "HaveYouCheckedThatTheSubjectIsNotSufferingFromAnyMuscularInjuryConditionOrTraumaWhichWillAffectHisHerAbilityToCarryOutTheExerciseTestSafely";
export const HaveYouCheckedTheSubjectIsNotRecoveringFromAnAcuteIllnessOrHasAColdOrIsTakingBetaBlockerDrugsWhichWillDepressHeartRateScores
    = "HaveYouCheckedTheSubjectIsNotRecoveringFromAnAcuteIllnessOrHasAColdOrIsTakingBetaBlockerDrugsWhichWillDepressHeartRateScores";
export const StepHeight = "StepHeight";
export const PulseBpm0Minutes = "PulseBpm0Minutes";
export const PulseBpm2Minutes = "PulseBpm2Minutes";
export const RPE2Minutes = "RPE2Minutes";
export const PulseBpm4Minutes = "PulseBpm4Minutes";
export const RPE4Minutes = "RPE4Minutes";
export const PulseBpm6Minutes = "PulseBpm6Minutes";
export const RPE6Minutes = "RPE6Minutes";
export const PulseBpm8Minutes = "PulseBpm8Minutes";
export const RPE8Minutes = "RPE8Minutes";
export const PulseBpm10Minutes = "PulseBpm10Minutes";
export const RPE10Minutes = "RPE10Minutes";
export const ChesterStepAdditionalNotes = "ChesterStepAdditionalNotes";
// Section 3 - Chester Walk
export const ChesterStepNotes = "ChesterStepNotes";

// Other section questions
export const OtherNotes = "OtherNotes";
export const OtherAttachments = "OtherAttachments";
